import Vue from "vue";
import SearchApp from "./SearchApp.vue";

Vue.config.productionTip = false;

new Vue({
	el: "#searchApp",
	render: h => {
		const context = {
			props: {
				wpData: window.wpData
			}
		};
		return h(SearchApp, context);
	}
});
